import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { fetchAnalyticsView } from "../ExtendedAnalytics/api"
import ReviewsView from "../ExtendedAnalytics/ReviewsView"
import { querySearch } from "../ExtendedAnalytics/queryState"
import FeedbackOverview, { useFeedbackOverview } from "./FeedbackOverview"

const query = { view: "reviews", period: "last-30-days", comparison: "previous-adjacent", sport: "all", locationScope: "global" }

export default function ReviewOverview() {
  const [state, setState] = useState({ status: "loading" })
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    let active = true
    setState({ status: "loading" })
    fetchAnalyticsView(query).then(response => {
      if (active) setState({ status: "ready", snapshot: response.data })
    }).catch(error => {
      if (active) setState({ status: [401, 403].includes(error?.response?.status) ? "forbidden" : "error" })
    })
    return () => { active = false }
  }, [retry])
  const feedback = useFeedbackOverview()
  const group = <FeedbackOverview state={feedback.state} onRetry={feedback.retry} />
  if (state.status === "forbidden") return null
  const range = state.snapshot?.ranges.current
  const details = range ? { ...query, period: "custom", startDate: range.startDate, endDate: range.endDate } : query
  return <section id="review-overview" className="mt-4" aria-label="Review overview">
    <div className="project-section-heading"><div><h2>Reviews &amp; Reputation</h2>
      <p>Last 30 days{range ? ` · ${range.startDate} – ${range.endDate}` : ""}</p></div>
      <Link to={`/extended-analytics${querySearch(details)}`}>Extended Analytics</Link>
    </div>
    {state.status === "loading" && <p role="status">Loading reviews…</p>}
    {state.status === "error" && <div role="alert"><p>Review analytics are temporarily unavailable.</p><button className="btn btn-outline-primary" onClick={() => setRetry(value => value + 1)}>Try again</button></div>}
    {/* The „Tournament feedback” group sits under the review cards, or under the reviews' state while they cannot show. */}
    {state.status === "ready" ? <ReviewsView snapshot={state.snapshot} compact>{group}</ReviewsView> : group}
  </section>
}
